import { useCallback } from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import getMetrics from "src/organization/pages/project/environment/metrics/api/getMetrics";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";

import { httpMetricsQueryFields, httpMetricsQueryFilters } from "../config";
import { getMetricQuery } from "../helper";
import { HttpMetricsResponseType } from "../types";

const req = (href: string, timeFrame: TimeFrameType, collection: string) => {
  const query = getMetricQuery({
    collection,
    timeframe: timeFrame,
    fields: httpMetricsQueryFields,
    filters: httpMetricsQueryFilters,
    post_filters: [
      {
        name: "top",
        top: {
          n: 10,
          field: "request.url.method.impact",
          descending: true,
          consistent: true
        }
      }
    ]
  });
  return getMetrics<HttpMetricsResponseType>(href, query);
};

const useHttpMetricsPoll = ({ timeFrame }: { timeFrame: TimeFrameType }) => {
  const environment = useSelectorWithUrlParams(environmentSelector);
  const metricsLink = environment?.getLinks()?.["#metrics"]?.[0] as {
    collection?: string;
    href?: string;
  };

  const href = metricsLink?.href;
  const collection = metricsLink?.collection;

  const requestFn = useCallback(
    () => req(href!, timeFrame, collection!),
    [href, collection, timeFrame]
  );

  return usePoller({
    timeFrame,
    requestFn
  });
};

export default useHttpMetricsPoll;
